import React, { useState, useEffect } from 'react';
import ReactGA from 'react-ga4';

// Initialize Google Analytics
ReactGA.initialize('GT-5TN9KLXR'); // Replace with your actual Measurement ID
console.log('Google Analytics initialized!');

function App() {

  const [searchTerm, setSearchTerm] = useState('');
  const [trials, setTrials] = useState([]);
  const [loading, setLoading] = useState(false);
  const [summaries, setSummaries] = useState({});
  const [summarizing, setSummarizing] = useState({});

  // Track page view on mount
  useEffect(() => {
    console.log('Sending pageview to GA');
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  const searchTrials = async () => {
    if (!searchTerm.trim()) return;
    
     // Track the search
  ReactGA.event({
    category: 'Search',
    action: 'Clinical Trial Search',
    label: searchTerm
  });

    setLoading(true);
    
    try {
      const url = 'https://clinicaltrials.gov/api/v2/studies?query.term=' + 
                  encodeURIComponent(searchTerm + ' cancer') + 
                  '&filter.overallStatus=RECRUITING&pageSize=10';
      
      const response = await fetch(url);
      const data = await response.json();
      
      setTrials(data.studies || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

const summarizeTrial = async (trial, nctId) => {

    // Track summary request
  ReactGA.event({
    category: 'Engagement',
    action: 'Request Summary',
    label: nctId
  });

  setSummarizing(prev => ({ ...prev, [nctId]: true }));
  
  try {
    const protocol = trial.protocolSection;
    const description = protocol.descriptionModule?.briefSummary || 'No description available';
    const eligibility = protocol.eligibilityModule?.eligibilityCriteria || 'No criteria listed';
    const title = protocol.identificationModule?.officialTitle || 'Untitled study';
    
    const response = await fetch('/api/summarize', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: title,
        description: description,
        eligibility: eligibility
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to generate summary');
    }

    const data = await response.json();
    setSummaries(prev => ({ ...prev, [nctId]: data.summary }));
    
  } catch (err) {
    setSummaries(prev => ({ ...prev, [nctId]: 'Sorry, could not create summary right now.' }));
    console.error(err);
  } finally {
    setSummarizing(prev => ({ ...prev, [nctId]: false }));
  }
};


  return (
    <div style={{ padding: '40px', maxWidth: '1200px', margin: '0 auto' }}>
      <h1 style={{ textAlign: 'center', color: '#1e40af' }}>Plain Trials</h1>
      <p style={{ textAlign: 'center', marginBottom: '30px' }}>
        Cancer clinical trials explained in simple language
      </p>

      <div style={{ marginBottom: '30px' }}>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && searchTrials()}
          placeholder="Search for cancer type (e.g., breast, lung)..."
          style={{ 
            width: '70%', 
            padding: '12px', 
            fontSize: '16px',
            border: '2px solid #ccc',
            borderRadius: '8px'
          }}
        />
        <button
          onClick={searchTrials}
          disabled={loading}
          style={{
            marginLeft: '10px',
            padding: '12px 24px',
            fontSize: '16px',
            backgroundColor: '#4f46e5',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? 'Searching...' : 'Search'}
        </button>
      </div>

      <div>
        {trials.map((trial) => {
          const protocol = trial.protocolSection;
          const nctId = protocol.identificationModule?.nctId;
          const title = protocol.identificationModule?.briefTitle;
          
return (
  <div key={nctId} style={{ 
    backgroundColor: 'white', 
    padding: '20px', 
    marginBottom: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  }}>
    <h3>{title}</h3>
    <p>Study ID: {nctId}</p>
    
    {summaries[nctId] ? (
      <div style={{
        backgroundColor: '#eff6ff',
        padding: '15px',
        borderRadius: '8px',
        marginTop: '15px',
        marginBottom: '15px'
      }}>
        <h4 style={{ color: '#1e40af' }}>Simple Explanation</h4>
        <p style={{ whiteSpace: 'pre-line' }}>{summaries[nctId]}</p>
      </div>
    ) : (
      <button
        onClick={() => summarizeTrial(trial, nctId)}
        disabled={summarizing[nctId]}
        style={{
          marginTop: '10px',
          marginBottom: '10px',
          padding: '10px 20px',
          backgroundColor: '#818cf8',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: summarizing[nctId] ? 'not-allowed' : 'pointer'
        }}
      >
        {summarizing[nctId] ? 'Creating explanation...' : 'Explain in Simple Terms'}
      </button>
    )}
    
    <a 
      href={'https://clinicaltrials.gov/study/' + nctId}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: '#4f46e5' }}
    >
      View Full Details →
    </a>
  </div>
);

        })}
      </div>
    </div>
  );
}

export default App;
